<template>
    <section class="component" style="position: relative;  flex-grow: 1;">
        <section class="component__header">
            <span class="component__header__title">
                {{ $t("com.discussion.discussion-profile") }}
            </span>
            <section class="component__header__action">
                <button class="component__button component__button--small component__button--white" @click="$store.commit('setIsShowAddDiscussionProfileStatus', true)">
                    <img src="@/assets/icons/components/plus-small.svg" style="filter: invert(1);" />
                    <span class="component__button__text">{{ $t("com.global.add") }}</span>
                </button>
            </section>
        </section>
        <section class="component__body discussion-profile__body">
            <table
                v-if="isAnyDiscussionProfiles"
                class="table-bootstrap table-bootstrap-hover table-bootstrap-bordered table-bootstrap-striped align-middle"
            >
                <thead>
                    <tr class="align-middle">
                        <th>{{ $t("com.file.edit-announcement.name") }}</th>
                        <th>{{ $t("com.discussion.profile.default") }}</th>
                        <th>{{ $t("com.discussion.profile.modes") }}</th>
                        <th style="width: 20px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in availableDiscussionProfiles" :key="item.id || index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.defaults ? $t("com.global.yes") : $t("com.global.no") }}</td>
                        <td>{{ getModesCount(item) }}</td>
                        <td>
                            <ButtonGroup>
                                <ButtonOutline color="light" type="sm" @click="showDiscussionProfileModes(item)">
                                    {{ $t("com.discussion.profile.modes") }}
                                </ButtonOutline>
                                <ButtonOutline color="light" type="sm" @click="editDiscussionProfile(item)">
                                    <ButtonIcon icon="edit" />
                                    {{ $t("com.global.edit") }}
                                </ButtonOutline>
                                <ButtonOutline color="danger" type="sm" @click="deleteDiscussionProfile(item)" v-if="!item.defaults">
                                    <ButtonIcon icon="delete" />
                                    {{ $t("com.global.delete") }}
                                </ButtonOutline>
                            </ButtonGroup>
                        </td>
                    </tr>
                </tbody>
            </table>
            <section class="text-center" v-else>
                {{ $t("com.file.edit-point.no-discussion-profiles") }}
            </section>
        </section>
        <SmallLoader v-if="isLoading" />
    </section>
</template>
<script charset="utf-8">
import SmallLoader from "../../../BasicControls/SmallLoader.vue";
import DiscussionProfileService from "@/services/discussion.profile.service";
import { encryptStorage } from "@/services/encrypt.service";

export default {
    name: "DiscussionProfileComponent",
    components: {
        SmallLoader
    },
    data() {
        return {
            isLoading: false,
            discussionModule: encryptStorage.getItem("modules").d
        };
    },
    computed: {
        availableDiscussionProfiles() {
            return this.$store.state.discussionProfileStore.discussionProfiles;
        },
        isAnyDiscussionProfiles() {
            const discussionProfiles = this.availableDiscussionProfiles;
            return discussionProfiles !== undefined && discussionProfiles !== null && discussionProfiles.length > 0;
        }
    },
    async mounted() {
        try {
            if (this.isDiscussionModule() === false) {
                return;
            }

            this.isLoading = true;
            await DiscussionProfileService.GetAll();
        } catch (e) {
            console.log(e);
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        isDiscussionModule() {
            return this.discussionModule === 1;
        },
        getModesCount(profile) {
            if (!profile || !Array.isArray(profile.limits)) {
                return 0;
            }

            return profile.limits.length;
        },
        editDiscussionProfile(profile) {
            this.$store.commit("setSelectedDiscussionProfile", profile);
            this.$store.commit("setIsShowEditDiscussionProfileStatus", true);
        },
        showDiscussionProfileModes(profile) {
            this.$store.commit("setSelectedDiscussionProfile", profile);
            this.$router.push({
                name: "client-settings-discussion-profile-modes",
                params: {
                    discussionId: profile.id
                }
            });
        },
        async deleteDiscussionProfile(profile) {
            const actionToFire = async () => {
                try {
                    if (!profile?.id) {
                        return;
                    }

                    this.isLoading = true;
                    await DiscussionProfileService.Delete(profile.id);
                } finally {
                    this.isLoading = false;
                }
            };

            this.$store.commit("setAlertData", this.createAlertData());
            this.$store.commit("showConfirmationAlertWithData", actionToFire);
        },
        alertInfo() {
            let info = "";

            info += `<p>${this.$t("com.global.confirmation-alert")}</p>`;
            info += `<p>${this.$t("com.discussion.profile.remove-confirmation")}</p>`;

            return info;
        },
        createAlertData() {
            return {
                mainText: this.alertInfo(),
                buttons: [
                    {
                        id: 1,
                        text: this.$t("com.global.yes"),
                        color: "#d80418"
                    }
                ]
            };
        }
    }
};
</script>
<style lang="scss">
@use "@/assets/scss/user-profile-component.scss";

.discussion-profile__body {
    min-height: 150px;
}
</style>
